import { render } from "./IndustryTableManager.vue?vue&type=template&id=50f56590"
import script from "./IndustryTableManager.vue?vue&type=script&lang=js"
export * from "./IndustryTableManager.vue?vue&type=script&lang=js"

import "./IndustryTableManager.vue?vue&type=style&index=0&id=50f56590&lang=css"

import exportComponent from "/home/ubuntu/apps/crm/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__